import type { Sprint } from '../../../../model/types';

export const SprintsFetchStatus = {
	PENDING: 'PENDING',
	IN_PROGRESS: 'IN_PROGRESS',
	SUCCESS: 'SUCCESS',
	FAILURE: 'FAILURE',
} as const;

export type SprintsState = {
	data: Sprint[];
	fetchProgress: number;
	fetchProgressUpdate?: string;
	fetchStatus: (typeof SprintsFetchStatus)[keyof typeof SprintsFetchStatus];
	fetchError?: Error;
};
